<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-danger opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Está enfrentando algum problema? Deseja tirar alguma dúvida ou dar
              seu feedback? Você veio ao lugar certo! Preencha os campos abaixo
              para enviar sua mensagem à equipe Stars.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-7">
          <support-form />
        </div>
        <div class="col-lg-5 col-md-12 mt-4 mt-lg-0 text-center">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FAceleradoraStars%2F&tabs=timeline%2Cmessages&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1920525378239656"
            width="340"
            height="500"
            style="border: none; overflow: hidden"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "suporte_startup",
};
</script>
<style></style>
